import { useEffect } from "react";
import { api } from "../lib/api";
import { useI18n } from "../i18n/I18nProvider";

/**
 * SeoHead – on initial mount, fetches site-wide SEO settings from
 * /api/pages/seo and seeds things that are NOT handled per-page:
 *  - site-wide <title> fallback (only if still the EXACT static index.html default)
 *  - <meta name="keywords">
 *  - <meta name="twitter:site">   (Twitter handle)
 *
 * It deliberately does NOT touch og:title / og:description / og:image /
 * og:url / twitter:title / twitter:description / twitter:image — those are
 * owned by useDocumentMeta, which is called by every public page.
 */
const STATIC_INDEX_TITLE =
  "New Developments in Finca Cortesin, Casares | Luxury Golf Apartments & Villas";

function isStaticTitle() {
  return (document.title || "").trim() === STATIC_INDEX_TITLE;
}

function setMeta(attrName, attrValue, content) {
  if (!content) return;
  const sel = `meta[${attrName}="${attrValue}"]`;
  let el = document.querySelector(sel);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attrName, attrValue);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function SeoHead() {
  const { lang } = useI18n();
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/pages/seo");
        if (!data) return;

        if (data.site_title && isStaticTitle()) {
          document.title = data.site_title;
        }

        setMeta("name", "keywords", data.site_keywords);
        setMeta("name", "twitter:site", data.twitter_handle);
      } catch (_err) {
        /* keep static fallback from index.html */
      }
    })();
  }, [lang]);

  return null;
}
